import { useEffect, useMemo, useState } from "react";
import styles from "./new.module.scss";
import { Divider } from "@mui/material";
import Button from "../../../components/Button";
import SellModal from "../../../containers/Sell/SellModalContainer";
import { SellNewProps } from "../../../interfaces/salePost";
import { capitalize, formatInput, removePointsInText } from "../../../helpers/app";
import TextFieldShared from "../../../components/TextField/TextField";
import SelectShared from "../../../components/Select/Select";
import AddIcon from '@mui/icons-material/Add';
import FileUploader from "../../../components/FileUploader";
import VariantContainer from "../../../containers/Sell/NewContainer/VariantContainer/VariantContainer";
import { FUEL_TYPES } from "../../../constants/Publication";
import { TRANSMISSION_TYPES } from "../../../constants/salePost";
import { useToast } from "../../../helpers/hooks";
import Modal from "../../../components/Modal";
import { HexColorPicker } from "react-colorful";
import { images } from "../../../constants/images";
import { MODAL_SELL_TEXTS } from "../../../constants/offers";
import { useNavigate } from "react-router-dom";

const New = ({
    user,
    brand,
    getModels,
    models,
    cleanGetModels,
    getVersions,
    versionsFetching,
    versionsData,
    cleanGetVersions,
    variants,
    setNewVariant,
    setRemoveVariant,
    datasheet,
    postDatasheetFile,
    clearPostDatasheetFile,
    deleteDatasheetFile,
    clearDeleteDatasheetFile,
    colors,
    setColorReducer,
    updateVariants,
    postPublicationNew,
    fetchingPostPublication,
    cleanPostPublicationNew
}: SellNewProps) => {
    const toast = useToast();
    const navigate = useNavigate();
    const [model, setModel] = useState<any>({value: "", error: ""});
    const [version, setVersion] = useState<any>({value: "", error: ""});
    const [engine, setEngine] = useState<any>({value: "", error: ""});
    const [price, setPrice] = useState<any>({value: "", error: ""});
    const [transmission, setTransmission] = useState<any>({value: "", error: ""});
    const [financingBonus, setFinancingBonus] = useState<any>({value: "", error: ""});
    const [fuel, setFuel] = useState<any>({value: "", error: ""});
    const [efficiency, setEfficiency] = useState<any>({value: "", error: ""});
    const [nameColor, setNameColor] = useState<any>({value: "", error: ""});
    const [codeColor, setCodeColor] = useState<any>({value: "#FFFFFF", error: ""});
    const [colorModal, setColorModal] = useState<boolean>(false);
    const [datasheetError, setDatasheetError] = useState<string>("");
    const [openModalSuccessPost, setOpenModalSuccessPost] = useState<boolean>(false);
    
    const onPressSave = () => {
        if(!variants){
            toast("Debes ingresar una variante");
            return;
        }

        const modelSelected = modelsNormalized && modelsNormalized?.find((item: any) => item?.id === model?.value);
        const versionSelected = versionsNormalized && versionsNormalized?.find((item: any) => item?.id === version?.value);
        const transmissionSelected = transmissionsNormalized && transmissionsNormalized?.find((item: any) => item?.id === transmission?.value);
        const fuelSelected = fuelsNormalized && fuelsNormalized?.find((item: any) => item?.id === fuel?.value);

        let someError: boolean = false;

        if(!modelSelected){
            setModel({...model, error: "Debes seleccionar un modelo"});
            someError = true;
        } 
        if(!versionSelected){
            setVersion({...version, error: "Debes seleccionar una versión"});
            someError = true;
        } 
        if(!price?.value){
            setPrice({...price, error: "Debes ingresar un valor"});
            someError = true;
        } 
        if(!engine?.value){
            setEngine({...engine, error: "Debes ingresar un motor"});
            someError = true;
        } 
        if(!transmissionSelected){
            setTransmission({...transmission, error: "Debes seleccionar una transmisión"});
            someError = true;
        } 
        if(!financingBonus?.value){
            setFinancingBonus({...financingBonus, error: "Debes ingresar un valor"});
            someError = true;
        } 
        if(!fuelSelected){
            setFuel({...fuel, error: "Debes seleccionar un combustible"});
            someError = true;
        } 
        if(!efficiency?.value){
            setEfficiency({...efficiency, error: "Debes ingresar un valor"});
            someError = true;
        }
        if(datasheet?.data.length === 0){
            setDatasheetError("Debes seleccionar un archivo");
            someError = true;
        }

        let variantsError: boolean = variants && variants.some((variant: any) => {
            const colorError = (variant.color?.data?.value === "") ? "Debes seleccionar un color" : "";
            const stockError = (variant.stock?.value === "") ? "Debes ingresar un valor" : "";
            const interiorFilesError = (variant.interiorFiles?.length === 0) ? "Debes seleccionar al menos una foto" : "";
            const exteriorFilesError = (variant.exteriorFiles?.length === 0) ? "Debes seleccionar al menos una foto" : "";
            const backgroundFileError = (variant.backgroundFile?.length === 0) ? "Debes seleccionar una foto" : "";

            if(colorError || stockError || interiorFilesError || exteriorFilesError || backgroundFileError){
                updateVariants({
                    id: variant?.id,
                    color: {...variant?.color, error: colorError}, 
                    stock: {...variant?.stock, error: stockError},
                    interiorFiles: {...variant?.interiorFiles, error: interiorFilesError},
                    exteriorFiles: {...variant?.exteriorFiles, error: exteriorFilesError},
                    backgroundFile: {...variant?.backgroundFile, error: backgroundFileError}
                });
                return true;
            }else{
                return false;
            }
        })

        if(variantsError || someError){
            toast("Faltan campos por completar");
            return;
        }

        const stock = variants && variants.map((variant: any) => {
            return {
                name: variant?.color?.data?.name,
                code: variant?.color?.data?.value,
                quantity: variant?.stock?.value,
                pictures: [
                    {
                        type: "external",
                        images: variant?.exteriorFiles?.value && variant?.exteriorFiles?.value.map((file: any) => file?.id)
                    },
                    {
                        type: "internal",
                        images: variant?.interiorFiles?.value && variant?.interiorFiles?.value.map((file: any) => file?.id)
                    },
                    {
                        type: "background",
                        images: [variant?.backgroundFile?.value && variant?.backgroundFile?.value[0]?.id]
                    }
                ]
            }
        });

        const body = {
            country: "Chile",
            region: "Atacama",
            article: {
                brand: brand?.value,
                brand_id: brand?.id,
                model: modelSelected?.name,
                model_id: modelSelected?.id,
                version: versionSelected?.name,
                version_id: versionSelected?.id,
                price: removePointsInText(price?.value),
                fuel: fuelSelected?.value,
                transmission: transmissionSelected?.value,
                engine: engine?.value,
                fuel_efficiency: efficiency?.value,
                bonus_up_to: removePointsInText(financingBonus?.value)
            },
            stock: stock,
            origen: "particular",
            datasheet: [datasheet?.data[0]?.id ?? ""]
        };
        // Post publication
        postPublicationNew(body);
    };

    const onCloseModalSuccessPost = () => {
        setOpenModalSuccessPost(false);
        navigate("/profile/my_publications");
    }

    const onPressSaveColor = () => {
        const existNameColor = colors && colors.some((color: any) => color.label.toLowerCase() === nameColor?.value.toLowerCase());
        if(existNameColor){
            toast("El nombre del color ya esta definido");
            return;
        }
        const existCodeColor = colors && colors.some((color: any) => color.code.toLowerCase() === codeColor?.value.toLowerCase());
        if(existCodeColor){
            toast("Este color ya existe");
            return;
        }
        setColorReducer(codeColor?.value, nameColor?.value);
        setColorModal(false);
    }

    const onChangeColorCode = (value: any) => {
        if(value.length > 7){
            return;
        }
        if(!value.match("#") && value.length <= 6){
            value = "#" + value;
        }
        setCodeColor({...codeColor, value: value});
    }

    const onDeleteVariant = (id: number) => {
        setRemoveVariant(id);
        return;
    }
    
    const onAddVariant = () => {
        const id = Math.floor(Math.random() * 0x10000)
        const item: any = {
            id: id,
            color: {data: {name: "", value: ""}, error: ""},
            stock: {value: "", error: ""},
            interiorFiles: {value: [], error: ""},
            exteriorFiles: {value: [], error: ""},
            backgroundFile: {value: [], error: ""},
            variant: <VariantContainer 
                id={id} 
                onOpenModalColor={() => setColorModal(true)}
                onDelete={onDeleteVariant}
            />
        };
        setNewVariant(item);
        return;
    }

    const onChangeFileUploader = (files: any) => {
        const file = files[0];

        if(file.toDelete){
            deleteDatasheetFile(file?.id);
            return;
        }
        if(file?.previewURL){
            let formData = new FormData();
            formData.append("file", file?.file, file?.name);
            postDatasheetFile(formData, "datasheet");
        }
    }

    const onChangeModel = (value: any) => {
        const year = 2024;
        setModel({...model, value: value});
        getVersions({
            model_id: value, 
            year: year
        });
    }

    const onChangeFormattedValue = (value: any, setState: any) => {
        const { formattedNumber } = formatInput(value);
        setState((prevState: any) => ({...prevState, value: formattedNumber}));
    }

    const modelsNormalized: any = useMemo(() => {
        return models?.data && models?.data.map((model: any) => (
            {
                id: model?.model_id,
                name: model?.name
            }
        ))
    }, [models?.data]);

    const versionsNormalized: any = useMemo(() => {
        return versionsData && versionsData.map((version: any) => (
            {
                id: version?.version_id,
                name: version?.name
            }
        ))
    }, [versionsData]);

    const transmissionsNormalized: any = useMemo(() => {
        return TRANSMISSION_TYPES && TRANSMISSION_TYPES.map((transmission: any, index: number) => (
            {
                id: index,
                name: transmission,
                value: transmission
            }
        ))
    }, [TRANSMISSION_TYPES]);

    const fuelsNormalized: any = useMemo(() => {
        return FUEL_TYPES && FUEL_TYPES.map((fuel: any, index: number) => (
            {
                id: index,
                name: capitalize(fuel),
                value: fuel
            }
        ))
    }, [FUEL_TYPES]);

    const disabled: boolean = useMemo(() => {
        if(variants && variants.length > 0){
            return !variants.every((item: any) => {
                const extFiles = (item?.exteriorFiles?.value && item?.exteriorFiles?.value.length > 0) ? item?.exteriorFiles?.value.every((file: any) => file?.upload === "success") : false;
                const intFiles = (item?.interiorFiles?.value && item?.interiorFiles?.value.length > 0) ? item?.interiorFiles?.value.every((file: any) => file?.upload === "success") : false;
                const bkgrFile = item?.backgroundFile?.value[0]?.upload === "success";
                return (extFiles && intFiles && bkgrFile);
            })
        }else{
            return true
        }
    }, [variants]);

    useEffect(() => {
        if(fetchingPostPublication === "failure"){
            toast("Ha ocurrido un error al publicar");
            cleanPostPublicationNew();
        }
        if(fetchingPostPublication === "success"){
            setOpenModalSuccessPost(true);
            cleanPostPublicationNew();
        }
    }, [fetchingPostPublication]);

    useEffect(() => {
        if(datasheet?.fetching === "failure"){
            toast("Ha ocurrido un error al subir la imagen");
            clearPostDatasheetFile();
        }
        if(datasheet?.fetching === "success"){
            clearPostDatasheetFile();
        }
    }, [datasheet?.fetching]);

    useEffect(() => {
        if(datasheet?.delete?.fetching === "failure"){
            toast("Ha ocurrido un error al eliminar la imagen");
            clearDeleteDatasheetFile();
        }
        if(datasheet?.delete?.fetching === "success"){
            clearDeleteDatasheetFile();
        }
    }, [datasheet?.delete?.fetching]);
    
    useEffect(() => {
        if(versionsFetching === "failure"){
            toast("Ha ocurrido un error al mostrar las versiones");
            cleanGetVersions();
        }
        if(versionsFetching === "success"){
            cleanGetVersions();
        }
    }, [versionsFetching]);

    useEffect(() => {
        if(models?.fetching === "failure"){
            toast("Ha ocurrido un error al mostrar los modelos");
            cleanGetModels();
        }
        if(models?.fetching === "success"){
            cleanGetModels();
        }
    }, [models?.fetching]);

    useEffect(() => {
        getModels(brand?.id);
    }, []);

    return (
        <>
            <Modal open={openModalSuccessPost} onClose={() => setOpenModalSuccessPost(false)}>
                <div className={styles.successPost}>
                    <img alt="success" src={images.successModal} />
                    <p className={styles.title}>{MODAL_SELL_TEXTS["accepted"].title}</p>
                    <p className={styles.description}>{MODAL_SELL_TEXTS["accepted"].description}</p>
                    <Button onPress={onCloseModalSuccessPost} title={MODAL_SELL_TEXTS["accepted"].button} secondary />
                </div>
            </Modal>
            <Modal open={colorModal} variant="white" onClose={() => setColorModal(false)}>
                <div className={styles.colorModal}>
                    <h2>Color</h2>
                    <p className={styles.description}>Ingresá aqui el nombre o la descripción del color.</p>
                    <TextFieldShared
                        label="Nombre"
                        name="nameColor"
                        value={nameColor?.value}
                        className={styles.input}
                        onChange={(value: any) => setNameColor({...nameColor, value: value})}
                        error={nameColor?.error}
                    />
                    <div className={styles.codeSelector}>
                        <HexColorPicker 
                            color={codeColor?.value} 
                            className={styles.selector}
                            onChange={(value: any) => onChangeColorCode(value)}
                        />
                        <input 
                            type="text" 
                            value={codeColor?.value}
                            className={styles.value}
                            onChange={(event: any) => onChangeColorCode(event.target.value)}
                        />
                    </div>
                    <Button 
                        onPress={onPressSaveColor}
                        title="Guardar"
                        primary
                        className={styles.button}
                        disabled={!nameColor?.value || !codeColor?.value}
                    />
                </div>
            </Modal>
            <SellModal
                step={0}
                title="Ingrese los datos del vehículo"
            >
                <div className={styles.container}>
                    <div className={styles.form}>
                        <SelectShared
                            label="Marca"
                            name="brand"
                            value="Citroen"
                            className={styles.full}
                            options={[brand]}
                            keyValue="value"
                            disabled
                            arrow={false}
                        />
                        <SelectShared
                            label="Modelo"
                            name="model"
                            value={model?.value}
                            className={styles.full}
                            onChange={onChangeModel}
                            options={modelsNormalized}
                            loading={models?.fetching === "loading"}
                            error={model?.error}
                        />
                        <SelectShared
                            label="Version"
                            name="version"
                            value={version?.value}
                            className={styles.full}
                            onChange={(value: any) => setVersion({...version, value: value})}
                            options={versionsNormalized}
                            loading={versionsFetching === "loading"}
                            error={version?.error}
                            optionsEmptyMessage="Debes seleccionar un modelo"
                        />
                        <TextFieldShared
                            label="Motor"
                            name="engine"
                            value={engine?.value}
                            className={styles.half}
                            onChange={(value: any) => setEngine({...engine, value: value})}
                            error={engine?.error}
                        />
                        <TextFieldShared
                            label="Precio"
                            name="price"
                            value={price?.value}
                            className={styles.half}
                            onChange={(value: any) => onChangeFormattedValue(value, setPrice)}
                            error={price?.error}
                        />
                        <SelectShared
                            label="Transmisión"
                            name="transmission"
                            value={transmission?.value}
                            className={styles.half}
                            onChange={(value: any) => setTransmission({...transmission, value: value})}
                            options={transmissionsNormalized}
                            error={transmission?.error}
                        />
                        <TextFieldShared
                            label="Bono con financiamiento"
                            name="financingBonus"
                            value={financingBonus?.value}
                            className={styles.half}
                            onChange={(value: any) => onChangeFormattedValue(value, setFinancingBonus)}
                            error={financingBonus?.error}
                        />
                        <SelectShared
                            label="Combustible"
                            name="fuel"
                            value={fuel?.value}
                            onChange={(value: any) => setFuel({...fuel, value: value})}
                            className={styles.half}
                            options={fuelsNormalized}
                            error={fuel?.error}
                        />
                        <TextFieldShared
                            label="Rendimiento"
                            name="efficiency"
                            value={efficiency?.value}
                            className={styles.half}
                            onChange={(value: any) => setEfficiency({...efficiency, value: value})}
                            error={efficiency?.error}
                        />
                    </div>
                    <div className={`${styles.fileSelector} ${styles.datasheet}`}>
                        <p className={styles.title}>Ficha técnica del vehículo (requerido)</p>
                        <FileUploader 
                            values={datasheet?.data} 
                            onChange={onChangeFileUploader} 
                            className={styles.fileUploader} 
                            description="Sube tu archivo en formato PDF con un máximo hasta 10 MB de peso."
                            limit={1}
                            enumeration={false}
                            multiple={false}
                            accept="application/pdf"
                        />
                        {
                            datasheetError && datasheetError !== "" && 
                            <p className={styles.error}>{datasheetError}</p>
                        }
                    </div>
                    <Divider />
                    {
                        variants && variants.map((item: any) => (
                            <>
                                {item?.variant}
                                <Divider />
                            </>
                        ))
                    }
                    <div className={styles.addVariant} onClick={onAddVariant}>
                        <AddIcon className={styles.icon} />
                        <p>Nueva variante</p>
                    </div>
                    <Divider />
                    <Button 
                        onPress={onPressSave}
                        title="Guardar"
                        primary
                        className={`${styles.button} ${styles.full}`}
                        disabled={disabled}
                        loading={fetchingPostPublication === "loading"}
                    />
                </div>
            </SellModal>
        </>
    )
};

export default New;